import { Inject } from '@odinjs/odin';
import { DynamicFieldsAPI, FormAPI, Metadata } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { FragmentNames, PseudonymAppointmentsQuizAnswerViewAliases } from '../../../../codegen';
import { APPLICATION_ENDPOINTS } from '../../../../constants/application-endpoints';
import PseudonymAppointmentsBaseController from '../../pseudonym-appointments-base-controller';
import { AppointmentQuizAnswerViewParameters } from '../../pseudonym-interfaces';

const QuizItemType = {
  RADIO_GROUP: 'G'
}

@Controller({ component: PseudonymAppointmentsQuizAnswerViewAliases.LAYOUT_QUIZ_ANSWER_VIEW, fragment: FragmentNames.PSEUDONYM_APPOINTMENTS_QUIZ_ANSWER_VIEW })
export default class PseudonymAppointmentsQuizAnswerViewController extends PseudonymAppointmentsBaseController {

  @Inject(PseudonymAppointmentsQuizAnswerViewAliases.DYNAMIC_FIELDS_QUIZ_ANSWER_VIEW)
    dynamicFieldsQuizAnswerViewApi!: DynamicFieldsAPI;

  @Inject(PseudonymAppointmentsQuizAnswerViewAliases.FORM_QUIZ_ANSWER_VIEW)
    formQuizAnswerViewApi!: FormAPI;

  @OnMount({ target: PseudonymAppointmentsQuizAnswerViewAliases.DYNAMIC_FIELDS_QUIZ_ANSWER_VIEW })
  handleMountDynamicFieldsQuizQuestionAnswerView(): void {
    this.formQuizAnswerViewApi.setLoading(true);

    const quizAnswerViewParameters = this.context.get('quizAnswerViewParameters') as AppointmentQuizAnswerViewParameters;
    const parameters = {
      nrSeqAgendaIntItem: quizAnswerViewParameters.integratedScheduleItemSequence,
      readOnly: quizAnswerViewParameters.readOnly,
      seqAgeInt: quizAnswerViewParameters.integratedScheduleSequence
    } as Record<string, Value>;

    void HttpService.get<Metadata>(APPLICATION_ENDPOINTS.GET_QUIZ_METADATA, parameters)
      .then(response => {
        const dynamicMetada = response.body as Metadata;
        this.dynamicFieldsQuizAnswerViewApi.setMetadata(dynamicMetada);
        const quizAnswerMetadata = this.context.get('quizAnswerMetadata') as Array<Record<string, Value>>;
        this.fillQuizAnwserMetadata(quizAnswerMetadata);
      }).catch( () =>
        this.formQuizAnswerViewApi.setLoading(false)
      );
  }

  private formatAnswer(data: Record<string, Value>): Value {
    if (data.typeAnswer === QuizItemType.RADIO_GROUP) {
      return { key: data.sequenceAnswer?.toString() };
    }

    return data.answerGrid;
  }

  fillQuizAnwserMetadata(anwser: Array<Record<string, Value>>): void {
    const record: Record<string, Value> = {}

    anwser.forEach(data => {
      const key = data.sequenceStructure as string;
      record[key] = this.formatAnswer(data);
    });

    this.formQuizAnswerViewApi.setRecord(record);
    if (this.formQuizAnswerViewApi.isLoading()) {
      this.formQuizAnswerViewApi.setLoading(false);
    }
  }
}
